import React from 'react'
import { cn } from 'src/lib/cn'

type Props = {
  open: boolean
  setOpen?: (value: boolean) => void
  children: React.ReactNode
}

const Modal: React.FC<Props> = ({ open, children }) => {
  return (
    <div
      className={cn(`relative z-40`, open ? 'block' : 'hidden')}
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true" ></div>
      <div className="fixed inset-0 z-10 flex justify-center items-center w-screen overflow-y-auto">
        <div className="flex min-h-[200px] w-full justify-center p-4 text-center sm:items-center sm:p-0">
          <div className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl w-screen max-w-3xl transition-all sm:my-8 sm:max-w-lg">
            <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Modal
